import React, { useState } from "react";

import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import { AnimateDirection } from "@/components/Molecules/Modal";
import theme from "@/foundation/Theme";
import { Typography } from "@/foundation/Typography/V2";

import { StyledModal } from "../RegisterModal/style";
import { Container, Wrapper, Div, StyledCta, StyledCard } from "./style";

function HeroSection({
  width,
  handleScrollToUpcomingWebinar,
  handleScrollToPastWebinar,
  showPastWebinarList,
  showWebinarList,
  isWebinarRecordingsPage,
  data = {},
}: any) {
  const { title, subtitle, tag, primaryBtnText, secondaryBtnText } = data;

  const [showDialog, setShowDialog] = useState(false);

  const openDialog = () => setShowDialog(true);
  const closeDialog = () => setShowDialog(false);

  const primaryButton = (
    <StyledCta
      bgColor={theme.colorsV2.shyft.purple_text}
      hoverColor={theme.colorsV2.shyft.purple_text}
      variant="primary1"
      fontFamily={"var(--man-700)"}
      btnPadding={"15px 32px"}
      fontSize={["14px", "15px", "16px"]}
      version={"v2"}
      mr={width >= 992 ? "24px" : ""}
      mb={width <= 992 ? "24px" : ""}
      boxShadow={`0px 10px 20px rgba(${theme.colors.shadows.purple_3}, 0.18), 0px 2px 6px rgba(${theme.colors.shadows.purple_3}, 0.12), 0px 0px 1px rgba(${theme.colors.shadows.black}, 0.04)`}
      onClick={showWebinarList ? handleScrollToUpcomingWebinar : openDialog}
    >
      {primaryBtnText || "See Upcoming Webinars"}
    </StyledCta>
  );

  const secondaryButton = (
    <StyledCta
      bgColor={
        isWebinarRecordingsPage
          ? theme.colorsV2.shyft.purple_text
          : theme.colors.white
      }
      hoverColor={
        isWebinarRecordingsPage
          ? theme.colorsV2.shyft.purple_text
          : theme.colors.white
      }
      variant="primary1"
      fontFamily={"var(--man-700)"}
      btnPadding={"15px 32px"}
      fontSize={["14px", "15px", "16px"]}
      version={"v2"}
      TextColor={
        isWebinarRecordingsPage
          ? theme.colors.white
          : theme.colorsV2.shyft.purple_text
      }
      primaryBorderColor={theme.colorsV2.gray.shade_200}
      onClick={() => {
        handleScrollToPastWebinar();
        closeDialog();
      }}
    >
      <StyledSvgSprite
        icon={"icon-VideoCamera"}
        fill={
          isWebinarRecordingsPage
            ? theme.colors.white
            : theme.colorsV2.shyft.purple_text
        }
        height="24px"
        width="24px"
        mr="8px"
      />
      {secondaryBtnText || "Watch Past Webinars"}
    </StyledCta>
  );

  const modal = (
    <StyledModal
      overlayClosable
      onClose={() => setShowDialog(false)}
      width={width <= 1079 ? "100%" : "840px"}
      bottomYpos="0px"
      animateDirection={
        width <= 1079 ? AnimateDirection.BOTTOM : AnimateDirection.CENTER
      }
      borderRadius={width <= 1079 ? "24px 24px 0 0" : "24px"}
      bgCol={theme.colorsV2.shyft.purple_text}
    >
      <StyledCard borderRadius={width <= 1079 ? "24px 24px 0 0" : "24px"}>
        <Typography variant="label1">
          Sorry &#128542;, we don't have any upcoming webinars planned for the
          next 2 weeks but we will be back soon with something interesting so
          stay tuned. Till then, please watch our latest webinars from the
          section below.
        </Typography>
        {secondaryButton}
      </StyledCard>
    </StyledModal>
  );

  return (
    <Wrapper>
      <Container flexDirection={"column"}>
        <Div maxWidth={"920px"} width="100%" flexDirection={"column"}>
          {tag && (
            <Typography
              mb={"24px"}
              variant="label3"
              color={theme.colorsV2.shyft.purple_text}
              letterSpacing="0.12rem"
              isExtraBold
            >
              {tag}
            </Typography>
          )}
          {title && (
            <Typography
              mb={"24px"}
              variant="display3"
              color={theme.colorsV2.primary.shade_900}
              isExtraBold
            >
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography
              mb={"24px"}
              variant="label1"
              color={theme.colorsV2.primary.shade_900}
            >
              {subtitle}
            </Typography>
          )}
          <Div
            flexDirection={width >= 992 ? "row" : "column"}
            alignItems={width >= 992 ? "center" : "flex-start"}
          >
            {showWebinarList && primaryBtnText && primaryButton}
            {showPastWebinarList && secondaryBtnText && secondaryButton}
          </Div>
        </Div>
      </Container>
      {showDialog && modal}
    </Wrapper>
  );
}

export default HeroSection;
